(function() {
    'use strict';

    angular
        .module('capacitacionCertificacionApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('certificate', {
            parent: 'entity',
            url: '/certificate?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'capacitacionCertificacionApp.certificate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/certificate/certificates.html',
                    controller: 'CertificateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('certificate');
                    $translatePartialLoader.addPart('person');
                    $translatePartialLoader.addPart('certification');
                    $translatePartialLoader.addPart('documentTypes');
                    $translatePartialLoader.addPart('terminals');
                    $translatePartialLoader.addPart('accessType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('certificate-detail', {
            parent: 'certificate',
            url: '/certificate/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'capacitacionCertificacionApp.certificate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/certificate/certificate-detail.html',
                    controller: 'CertificateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('certificate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Certificate', function($stateParams, Certificate) {
                    return Certificate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'certificate',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('certificate-detail.edit', {
            parent: 'certificate-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/certificate/certificate-dialog.html',
                    controller: 'CertificateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Certificate', function(Certificate) {
                            return Certificate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('certificate.new', {
            parent: 'certificate',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/certificate/certificate-dialog.html',
                    controller: 'CertificateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                age: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('certificate', null, { reload: 'certificate' });
                }, function() {
                    $state.go('certificate');
                });
            }]
        })
        .state('certificate.edit', {
            parent: 'certificate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/certificate/certificate-dialog.html',
                    controller: 'CertificateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Certificate', function(Certificate) {
                            return Certificate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('certificate', null, { reload: 'certificate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('certificate.delete', {
            parent: 'certificate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/certificate/certificate-delete-dialog.html',
                    controller: 'CertificateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Certificate', function(Certificate) {
                            return Certificate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('certificate', null, { reload: 'certificate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
